export default "__VITE_ASSET__833c3477__"